import { Input, message, Modal } from 'antd';
import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import { useIntl } from 'react-intl';
import { Fragment, useRef, useState } from 'react';
import { createContract } from '~src/services/api/contracts';
import { queryCache, useMutation } from 'react-query';
import { appLog } from '~src/utils/log';

const initialFormValues = {
  name: '',
  description: '',
  reference: '',
};

export const ContractBuilderCreateContractModal = ({
  projectId,
  tenderId,
  visible,
  onCancel,
  ...modalProps
}) => {
  const intl = useIntl();

  const [formValues, setFormValues] = useState(initialFormValues);
  const referenceInputRef = useRef<Input>(null);
  const nameInputRef = useRef<Input>(null);
  const descriptionInputRef = useRef<Input>(null);

  const [doCreateContract, { isLoading }] = useMutation(createContract, {
    onSuccess: () => {
      queryCache.invalidateQueries('contracts');
    },
    onError: (err) => {
      appLog(`creating contract error ->`, err);
    },
  });

  const isValid = () => {
    if (!formValues.name) return false;

    return true;
  };

  const handleSubmit = async () => {
    if (!isValid()) {
      message.error('Please fill in all required fields');
      return;
    }

    await doCreateContract({
      projectId,
      tenderId,
      data: {
        name: formValues.name,
        description: formValues.description,
        reference: formValues.reference,
      },
    });

    setFormValues(initialFormValues);
    onCancel?.();
  };

  return (
    <Modal
      title={
        <ModalTitle
          text={intl.formatMessage({ id: 'create-contract' })}
          icon={['far', 'ticket']}
        />
      }
      okText={intl.formatMessage({ id: 'save' })}
      cancelText={intl.formatMessage({ id: 'cancel' })}
      width={425}
      centered
      visible={visible}
      onOk={handleSubmit}
      confirmLoading={isLoading}
      okButtonProps={{ disabled: !isValid() }}
      onCancel={onCancel}
      destroyOnClose
      {...modalProps}>
      <Fragment>
        <Input
          ref={referenceInputRef}
          placeholder={intl.formatMessage({ id: 'reference' })}
          allowClear
          value={formValues.reference}
          onChange={(e) =>
            setFormValues({ ...formValues, reference: e.target.value })
          }
          style={{ marginBottom: 10 }}
        />
        <Input
          ref={nameInputRef}
          placeholder={intl.formatMessage({ id: 'name' })}
          allowClear
          value={formValues.name}
          onChange={(e) =>
            setFormValues({ ...formValues, name: e.target.value })
          }
          style={{ marginBottom: 10 }}
        />
        <Input
          ref={descriptionInputRef}
          placeholder={intl.formatMessage({ id: 'description' })}
          allowClear
          value={formValues.description}
          onChange={(e) =>
            setFormValues({ ...formValues, description: e.target.value })
          }
        />
      </Fragment>
    </Modal>
  );
};
